import { api } from '../../lib/api';
import type { ProviderHealth } from './types';

interface ProvidersResponse {
  providers: ProviderHealth[];
  generatedAt: string;
}

interface PlatformResponse {
  sections: ProviderHealth[];
  generatedAt: string;
}

export function fetchProviders(opts: { force?: boolean } = {}): Promise<ProvidersResponse> {
  const path = opts.force ? '/admin/health/providers?refresh=1' : '/admin/health/providers';
  return api.get<ProvidersResponse>(path);
}

export function fetchPlatform(opts: { force?: boolean } = {}): Promise<PlatformResponse> {
  const path = opts.force ? '/admin/health/platform?refresh=1' : '/admin/health/platform';
  return api.get<PlatformResponse>(path);
}
